<template>
  <div class="container">
    <h1 class="text-center">ag-grid | 一款基于vuejs的数据表格组件</h1>
    <div class="htmleaf-links">
      <a
        class="htmleaf-icon icon-htmleaf-home-outline"
        href="http://www.htmleaf.com/"
        title="jQuery之家"
        target="_blank"
      >
        <img
          width="120px"
          style="width: 120px"
          src="./assets/img/logo.png"
          alt="jQuery之家"
        />
      </a>
    </div>
    <div style="width: 650px; margin: 0 auto">
      <p>最简单的表格示例：</p>
      <ag-grid-vue
        style="width: 620px; height: 200px"
        class="ag-theme-alpine"
        :columnDefs="columnDefs"
        :rowData="rowData"
      >
      </ag-grid-vue>
    </div>
    <div class="related">
      <h3>如果你喜欢这个插件，那么你可能也喜欢:</h3>
      <a href="http://www.htmleaf.com/vue/vue-component/202303035920.html">
        <img src="./assets/img/1.jpg" width="300" />
        <h3>vue-agile|基于Vue.js的轮播图插件</h3>
      </a>
      <a href="http://www.htmleaf.com/vue/vue-component/202303015918.html">
        <img src="./assets/img/2.jpg" width="300" />
        <h3>vue-owl-carousel|基于Vue的响应式轮播插件</h3>
      </a>
    </div>
  </div>
</template>

<script>
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
// 在vue3 中使用，需要从ag-grid-vue3包中导入
import { AgGridVue } from 'ag-grid-vue3'

export default {
  name: 'App',
  components: {
    AgGridVue
  },
  setup() {
    return {
      columnDefs: [
        { headerName: 'Make', field: 'make' },
        { headerName: 'Model', field: 'model' },
        { headerName: 'Price', field: 'price' }
      ],
      rowData: [
        { make: 'Toyota', model: 'Celica', price: 35000 },
        { make: 'Ford', model: 'Mondeo', price: 32000 },
        { make: 'Porsche', model: 'Boxster', price: 72000 }
      ]
    }
  }
}
</script>

<style lang="scss">
.example-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#myGrid {
  flex: 1 1 0px;
  width: 100%;
}
</style>
